/* istanbul ignore file */
export * from './HorizontalScroll';
